import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from '~services/auth.service';
import { StoreService } from '~services/store.service';
import { UserService } from '~services/user.service';
import { ConfigValuesService } from '~services/config-values.service';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { IntercomService } from 'src/app/intercom.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from '~services/local-storage.service';

@Component({
  selector: 'sa-nav-lmo',
  templateUrl: './nav-lmo.component.html',
  styleUrls: ['./nav-lmo.component.scss'],
})
export class NavLmoComponent implements OnInit {
  public isGroupedAccountUser$: Observable<boolean>;
  public optedInToNewBillingPortal = true;
  public isAdmin = false;
  public isDefault = false;
  public isViewOnly = false;
  public isCrewLeader = false;
  public isDispatcher = false;
  public isSandCoordinator = false;
  public emailHelpLink = 'mailto:help@shaleapps.com';
  public userLabel: { name: string; email: string; account: string };
  @Input() expanded: boolean;
  @Output() linkClicked = new EventEmitter<boolean>();

  private subscription: Subscription;

  constructor(
    private authService: AuthService,
    private storeService: StoreService,
    public userService: UserService,
    private configService: ConfigValuesService,
    private intercom: IntercomService,
    private snackBar: MatSnackBar,
    private localStorageService: LocalStorageService,
  ) {
    this.setUserInfo();

    this.subscription = this.userService.userContract$.subscribe(() => {
      this.setUserInfo();
    });

    this.isGroupedAccountUser$ = this.authService.isGroupedAccountUser$;
  }

  private setUserInfo() {
    this.isAdmin = this.userService.isAdmin();
    this.isDefault = this.userService.isDefault();
    this.isViewOnly = this.userService.isViewOnly();
    this.isCrewLeader = this.userService.isCrewLeader();
    this.isDispatcher = this.userService.isDispatcher();
    this.isSandCoordinator = this.userService.isSandCoordinator();
    this.userLabel = this.userService.getLabel();
    const user = this.userService.getUserContractFromCache();
    if (user && user.account) {
      this.emailHelpLink = `mailto:help@shaleapps.com?body=Hi%20ShaleApps%20Help%20Team%2C%0D%0A%0D%0A%5BLet%20us%20know%20how%20we%20can%20help%20you%20here!%5D%0D%0A%0D%0AThanks%2C%0D%0A${user.name}%0D%0A%0D%0ADiagnostic%20Info%3A%0D%0AName%3A%20${user.name}%0D%0AEmail%3A%20${user.email}%0D%0AAccount%3A%20${user.account.name}%0D%0AURL%3A%20${location.href}%0D%0ABrowser%3A%20${navigator.userAgent}%0D%0A%0D%0A`;
    }
  }

  ngOnInit() {}

  showIntercom() {
    this.intercom.showNewMessage();
  }

  clickLink() {
    this.linkClicked.emit(true);
    if (this.localStorageService?.getItem('well_creation_site_location')) {
      this.localStorageService.removeItem(`well_creation_site_location`);
    }
  }

  logout() {
    this.storeService.clear();
    this.authService.logout();
  }
}
